import { RootComponentListPageState } from ".";
export const RootComponentListPageInitialState: RootComponentListPageState = {
  searchResult: {
    rootCpntList: [],
  },
  dataList: {
    inDefCommonFlagType: [],
  },
};
